import {
  FETCH_CUSTOM_GROUPS,
  FETCH_CUSTOM_GROUPS_SUCCESS,
  FETCH_CUSTOM_GROUPS_FAILURE,
  FETCH_CUSTOM_GROUP_ITEMS,
  FETCH_CUSTOM_GROUP_ITEMS_SUCCESS,
  FETCH_CUSTOM_GROUP_ITEMS_FAILURE,
  DELETE_CUSTOM_GROUP,
  DELETE_CUSTOM_GROUP_SUCCESS,
  DELETE_CUSTOM_GROUP_FAILURE,
  FETCH_CUSTOM_GROUP_ITEM_TYPES_SUCCESS,
  CREATE_CUSTOM_GROUP,
  CLEAR_CREATED_CUSTOM_GROUP,
  ENTER_CUSTOM_GROUP_EDIT_MODE,
  EXIT_CUSTOM_GROUP_EDIT_MODE,
  SELECT_CUSTOM_GROUP,
  SELECT_CUSTOM_GROUP_ITEM_TYPE,
  EDIT_CUSTOM_GROUP_SUCCESS,
  EDIT_CUSTOM_GROUP_FAILURE,
  REFRESH_CUSTOM_GROUP,
  REFRESH_CUSTOM_GROUP_FAILURE,
  REFRESH_CUSTOM_GROUP_SUCCESS,
  FETCH_USER_PRIVILEGES,
  FETCH_USER_PRIVILEGES_SUCCESS,
  FETCH_USER_PRIVILEGES_FAILURE,
} from './types';

import initialState from './initialState';

function customGroups(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_PRIVILEGES:
      return {
        ...state,
        fetchingUserPrivileges: true,
      };
    case FETCH_USER_PRIVILEGES_SUCCESS:
      return {
        ...state,
        isArchiveAdmin: action.isArchiveAdminFlag,
        fetchingUserPrivileges: false,
      };
    case FETCH_USER_PRIVILEGES_FAILURE:
      return {
        ...state,
        fetchingUserPrivileges: false,
      };
    case FETCH_CUSTOM_GROUPS:
      return {
        ...state,
        customGroupsLoading: true,
      };
    case FETCH_CUSTOM_GROUPS_SUCCESS:
      return {
        ...state,
        customGroups: action.customGroups
          .map(group => ({
            ...group,
            itemsString: group.groupItem.map(item => item.itemLabel).join(', '),
          }))
          .sort((a, b) => a.name.localeCompare(b.name)),
        customGroupsLoading: false,
      };
    case FETCH_CUSTOM_GROUPS_FAILURE:
      return {
        ...state,
        customGroupsLoading: false,
      };
    case FETCH_CUSTOM_GROUP_ITEMS:
      return {
        ...state,
        customGroupItemsLoading: true,
      };
    case FETCH_CUSTOM_GROUP_ITEMS_SUCCESS:
      return {
        ...state,
        customGroupItems: {
          CG: action.customGroupItems?.CG.filter(item => item.itemName),
          BR: action.customGroupItems?.BR.filter(item => item.itemName),
        },
        customGroupItemsLoading: false,
      };
    case FETCH_CUSTOM_GROUP_ITEMS_FAILURE:
      return {
        ...state,
        customGroupItemsLoading: false,
      };
    case DELETE_CUSTOM_GROUP:
      return {
        ...state,
        isDeletingCustomGroupInProgress: true,
        selectedCustomGroupId: null,
      };
    case DELETE_CUSTOM_GROUP_SUCCESS:
      return {
        ...state,
        isDeletingCustomGroupInProgress: false,
      };
    case DELETE_CUSTOM_GROUP_FAILURE:
      return {
        ...state,
        isDeletingCustomGroupInProgress: false,
      };
    case SELECT_CUSTOM_GROUP:
      return {
        ...state,
        selectedCustomGroupId: action.selectedCustomGroupId,
        isCreatingNewCustomGroup: false,
      };
    case FETCH_CUSTOM_GROUP_ITEM_TYPES_SUCCESS:
      return {
        ...state,
        customGroupItemTypes: action.customGroupItemTypes,
      };
    case CREATE_CUSTOM_GROUP:
      return {
        ...state,
        createdCustomGroup: {
          id: null,
          name: '',
          publicFlag: false,
          archivalFlag: false,
          sftpDeliveryFlag: false,
          allowEditFlag: false,
          groupItem: [],
        },
        isCreatingNewCustomGroup: true,
      };
    case CLEAR_CREATED_CUSTOM_GROUP:
      return {
        ...state,
        createdCustomGroup: null,
        isCreatingNewCustomGroup: false,
      };
    case ENTER_CUSTOM_GROUP_EDIT_MODE:
      return {
        ...state,
        selectedCustomGroupId: action.selectedCustomGroupId,
        readOnly: false,
      };
    case EXIT_CUSTOM_GROUP_EDIT_MODE:
      return {
        ...state,
        readOnly: true,
        createdCustomGroup: null,
        isCreatingNewCustomGroup: false,
      };
    case EDIT_CUSTOM_GROUP_SUCCESS:
    case EDIT_CUSTOM_GROUP_FAILURE:
      return {
        ...state,
      };
    case SELECT_CUSTOM_GROUP_ITEM_TYPE:
      return {
        ...state,
        selectedCustomGroupItemType: action.selectedCustomGroupItemType,
      };
    case REFRESH_CUSTOM_GROUP:
      return {
        ...state,
        isRefreshingCustomGroups: true,
      };
    case REFRESH_CUSTOM_GROUP_SUCCESS:
      return {
        ...state,
        isRefreshingCustomGroups: false,
      };
    case REFRESH_CUSTOM_GROUP_FAILURE:
      return {
        ...state,
        isRefreshingCustomGroups: false,
      };
    default:
      return state;
  }
}

export default customGroups;
